import React, { PureComponent } from 'react'

import { Pane } from 'evergreen-ui'
import { PlusCircleTwoTone, ApiTwoTone, VideoCameraOutlined, WarningOutlined } from '@ant-design/icons'
import { Button, Menu, Layout } from "antd";

import URLHelp from "../../components/Dialogs/URLHelp";
import AddCamera from "../../components/Dialogs/NewCamera";

import CameraMenu from '../../components/CameraMenu/CameraMenu'
import History from '../../components/History/History'

import { Camera, Tag, User, Detection } from '../../types'
import Datafetcher, { getCameraTagsResponseInterface } from '../../utils/datafetcher'

import "antd/dist/antd.css"
import Integrations from '../../components/Dialogs/Integrations'
import StripePayment from '../../components/Dialogs/StripePaymentSaver'


const { SubMenu } = Menu
const { Sider, Content } = Layout

interface Props {
  cameras: Camera[],
  user: User,
  datafetcher: Datafetcher,
  refreshInfo: () => void,
}

interface State {
  cameras: Camera[],
  activeCam: Camera | undefined,
  tags: Tag[]
  messages: Detection[],
  stream: string | undefined,
  refreshCam: boolean,
  width: number,
  height: number,
  newCameraModalShow: boolean,
  whereModal: boolean,
  showStripe: boolean,
  integrationsModalShow: boolean,
  collapsed: boolean,
}

export default class Home extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      cameras: [],
      activeCam: undefined,
      refreshCam: false,
      width: 0,
      height: 0,
      tags: [],
      stream: undefined,
      messages: [],
      newCameraModalShow: false,
      whereModal: false,
      showStripe: false,
      integrationsModalShow: false,
      collapsed: false,
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    const { cameras } = this.props;
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.setState({ cameras: cameras })
    this.cameraRefresher()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    })
  }

  UNSAFE_componentWillReceiveProps({ cameras }: { cameras: Camera[]}) {
    this.setState({
      ...this.state,
      cameras,
    }, () => { 
        const { activeCam } = this.state
        if (activeCam){
          cameras.forEach((camera) => { if(camera.id === activeCam.id){ this.setState({activeCam: camera}) } })
        }else{
          this.changeCamera(cameras[0])
        }
    })
  }

  cameraRefresher() {
    const { activeCam } = this.state;

    if (!activeCam) {
      setTimeout(() => this.cameraRefresher(), 60 * 1000)
      return;
    }
    this.setState({ refreshCam: true })
    setTimeout(() => this.setState({ refreshCam: false }), 500);
    setTimeout(() => this.cameraRefresher(), 60 * 1000);
  }

  setNewCameraModal = (val: boolean) => {
    this.setState({ newCameraModalShow: val })
  }

  changeCamera = (camera: Camera | undefined) => {
    const { datafetcher } = this.props;

    this.setState({ activeCam: camera })
    if (!camera) { return }

    datafetcher.getCameraTags(camera.id, (err: Error | null, resp: getCameraTagsResponseInterface | null) => {
      if (!resp) { return }
      this.setState({
        tags: resp.data.tags,
        stream: resp.data.stream
      })
    })
  }

  cameraDeleted = () => {
    const { cameras } = this.props
    if (cameras.length === 1) {
      this.setState({ activeCam: undefined })
    } else {
      this.changeCamera(cameras[0])
    }

    this.props.refreshInfo()
  }

  isMobile = () => {
    return this.state.width < 640
  }

  isCameraStable = (camera: Camera | undefined) => {
    if (!camera) { return false }
    return camera.inferences > 0
  }

  getCameraDropDown = () => {
    const { cameras } = this.state;
    return <Menu
      onClick={({ item, key }) => { this.changeCamera(cameras[Number(key)]) }}
      theme="dark"
      style={this.isMobile() ? { marginTop: -7.5 } : {}}
      defaultSelectedKeys={['0']}
      mode="inline">
      <SubMenu
        key="sub1"
        title={<span id="camera_picker"><VideoCameraOutlined /><span>Cameras</span></span>}>
        {cameras.map((camera, index) => {
          return <Menu.Item key={index}>
            {!this.isCameraStable(camera) ? <WarningOutlined /> : <></>}
            {camera.nickname}
          </Menu.Item>
        })}
      </SubMenu>
    </Menu>
  }

  getMenuButtons = () => {
    return <>
      <Button
        type="primary"
        id="step1"
        shape="round"
        onClick={() => { this.setState({ newCameraModalShow: true }) }}>
        <PlusCircleTwoTone />
      </Button>

      <Button
        type="default"
        shape="round"
        style={{ marginLeft: 8 }}
        onClick={() => this.setState({ integrationsModalShow: true })}>
        <ApiTwoTone />
      </Button>
    </>
  }

  historyHelper = () => {
    const { activeCam } = this.state;
    const { datafetcher} = this.props;
    if (activeCam) {
      return <History activeCam={activeCam} datafetcher={datafetcher} />
    } 
    return <></>
  }

  render() {
    const { user, datafetcher, refreshInfo } = this.props;
    const { activeCam, stream, cameras, tags, whereModal, newCameraModalShow, integrationsModalShow, refreshCam, showStripe } = this.state;

    return (
      <Pane clearfix>
        <URLHelp whereModal={whereModal}></URLHelp>

        <StripePayment
          display={(!user.paymentSaved && cameras.length > 0) || showStripe}
          user={user}
          datafetcher={datafetcher}
          setDisplay={value => this.setState({showStripe: value})}
        ></StripePayment>

        <AddCamera
          cameras={cameras}
          refreshInfo={refreshInfo}
          datafetcher={datafetcher}
          newCameraModalShow={newCameraModalShow}
          setNewCameraModal={this.setNewCameraModal}>
        </AddCamera>

        <Integrations 
          user={user} 
          setDisplay={value=>this.setState({integrationsModalShow: value})} 
          display={integrationsModalShow}>
        </Integrations>

        <Layout>
          {!this.isMobile() ?
            <Sider trigger={null} collapsible collapsed={this.state.collapsed} style={{ height: "100vh" }}>
              <Pane display="flex" flexDirection="row" justifyContent="center" marginTop={20} marginBottom={20}>
                {this.getMenuButtons()}
              </Pane>
              {this.getCameraDropDown()}
            </Sider>
            :
            <Pane style={{ background: "rgb(0, 21, 41)" }} >
              <Pane paddingLeft={10} paddingRight={10} display="flex" flexDirection="row" justifyContent="center">
                {this.getMenuButtons()}
                {this.getCameraDropDown()}
              </Pane>
            </Pane>}

          <Layout className="site-layout">
            <Content
              className="site-layout-background"
              style={{ margin: '24px 16px', padding: 6, minHeight: 280 }}>
              <Pane
                display="flex"
                flexDirection="row"
                marginBottom={this.isMobile() ? 10 : 0}>

                <CameraMenu
                  activeCam={activeCam}
                  stream={stream}
                  tags={tags}
                  datafetcher={datafetcher}
                  isMobile={this.isMobile()}
                  refreshInfo={refreshInfo}
                  refreshCam={refreshCam}
                  showNewCameraModal={() => { this.setNewCameraModal(true)}}
                  cameraDeleted={this.cameraDeleted}
                  changeCamera={this.changeCamera}
                ></CameraMenu>

                <Pane width={600} height={600} marginLeft={25}>
                  {!this.isMobile() ? this.historyHelper() : <></>}
                </Pane>

              </Pane>

              {this.isMobile() ? this.historyHelper() : <></>}

            </Content>
          </Layout>
        </Layout>
      </Pane>
    )
  }
}